export function OpenPage(pageName, options) {
  options = options || {};
  let newPath = '';
  // Get the index of the part of the path that starts with the path to
  // the source code (to indicate we are running code locally or on Cloud9)
  let photoheightIndex = window.location.pathname.indexOf('/source');
  // Check if we are running on Cloud9
  if (photoheightIndex != -1) {
    // Get the path before the start of the source code path
    newPath = window.location.pathname.substring(0, photoheightIndex);
    // Build the new path
    newPath += `/source/`;
  }

  // Add on the page name
  newPath += `${pageName}`;
  // Add on the hash if there is one
  if (options.hash) {
    // If the hash is an object, then convert it to a string
    if (typeof options.hash === 'object') options.hash = JSON.stringify(options.hash);
    newPath += `#${options.hash}`;
  }
  // Trim any whitespace
  newPath = newPath.trim();
  // Make sure the page starts with a slash
  if (newPath && newPath.substring(0, 1) != '/') {
    newPath = '/' + newPath;
  }

  // Build the final path and encode it
  let finalPath = window.location.origin + newPath;
  finalPath = encodeURI(finalPath);

  if (options.returnLink == true) {
    return finalPath;
  } else {
    window.open(finalPath, options.target || null);
  }
}
